window.cycFormatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var fmt = format || window.cycMoneyFormat || '{{amount_with_comma_separator}} €';
  var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
  if (!match) return (cents / 100).toFixed(2);
  function withDelims(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return 0;
    var n = (number / 100).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }
  var value;
  switch (match[1]) {
    case 'amount': value = withDelims(cents, 2, ',', '.'); break;
    case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
    case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
    case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
    default: value = withDelims(cents, 2, ',', '.');
  }
  return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
};

window.cycOnVariantChange = function (sectionId, callback) {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    if (!event || !event.data || !event.data.variant) return;
    if (sectionId && event.data.sectionId && event.data.sectionId !== sectionId) return;
    callback(event.data.variant);
  });
};

window.cycConfetti = function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
  document.body.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = window.innerWidth, H = window.innerHeight;
  canvas.width = W * dpr; canvas.height = H * dpr; ctx.scale(dpr, dpr);
  var colors = window.cycConfettiColors || ['#C8FF3D', '#0B0F14', '#FFFFFF', '#00C2FF', '#FF4D6D', '#FFD23F'];
  var parts = [];
  function burst(x, dir) {
    for (var i = 0; i < 70; i++) {
      var angle = (-Math.PI / 2) + dir * (Math.random() * 0.9 + 0.1) * 0.9;
      var speed = 9 + Math.random() * 9;
      parts.push({ x: x, y: H + 10, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, w: 6 + Math.random() * 6, h: 8 + Math.random() * 8, r: Math.random() * Math.PI, vr: (Math.random() - .5) * .3, c: colors[i % colors.length], life: 0 });
    }
  }
  burst(W * 0.1, 1); burst(W * 0.9, -1);
  var start = performance.now();
  function frame(t) {
    var el = t - start;
    ctx.clearRect(0, 0, W, H);
    parts.forEach(function (p) {
      p.vy += 0.28; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.r += p.vr;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r);
      ctx.globalAlpha = Math.max(0, 1 - el / 2600);
      ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r)) + 2);
      ctx.restore();
    });
    if (el < 2600) requestAnimationFrame(frame); else canvas.remove();
  }
  requestAnimationFrame(frame);
};

(function (init) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init(); })(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === 'product-form' && !window.cycConfettiOff) window.cycConfetti();
  });
});